import React from "react";
import { IKeyVal } from "../shared/Password";
import PropertyRowEdit from "./PropertyRowEdit";
import _ from "lodash";
import Button from "../gui/Button/Button";
import AddIcon from "../gui/Icons/AddIcon";

export interface IPropertyListProps {
    passwordId:string
    data:IKeyVal[]
    onAdd:Function
    onUpdate:(index:number,key:string,val:string) => void
    onDelete:(index:number) => void
}
export default function PropertyListEdit(props:IPropertyListProps) {
    const {data,passwordId} = props
    const onDelete = (index:number) => () => props.onDelete(index)
    const list = data.map((keyval,i) => <PropertyRowEdit key={keyval.key + "." + i} passwordId={passwordId} index={i} name={keyval.key} value={keyval.val} onDelete={onDelete(i)} onUpdate={props.onUpdate}/>)
    return <div className="properties">
        {list}
        <Button size="medium" className="mt-16" onClick={_=>props.onAdd()}><AddIcon/>Add</Button>
    </div>
}